var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { usePrefillDataCookie } from "@/components/contacting/ContactForm/usePrefillDataCookie";
import { useContactFormSection } from "@/contexts/contact";
import { useConsentService } from "@aviv-csnt/react";
import { useSendLead } from "@/hooks";
import { useSendSavedSearchOptIn } from "@/hooks/useSendSavedSearchOptIn";
import { useEffect } from "react";
import { ContactForm } from "./ContactForm";
import { ContactFormError } from "./ContactFormError";
import { useNormalizeNameFields } from "./../hooks/useNormalizeNameFields";
export const ContactFormWithLead = ({ close, av_zone, isModal, onError, }) => {
    const contactFormSection = useContactFormSection();
    const normalizeNameFields = useNormalizeNameFields();
    const { handleSubmit, loading, postLeadError } = useSendLead();
    const { handleSavedSearchOptIn } = useSendSavedSearchOptIn();
    const { setPrefillDataCookie } = usePrefillDataCookie();
    // Check if the consent is given for set the cookie
    const cookieConsent = "Contact Auto-fill";
    const { consentItems } = useConsentService();
    const handleSubmitAndClose = (data) => __awaiter(void 0, void 0, void 0, function* () {
        const filteredData = Object.assign({}, data);
        delete filteredData.suggestPrice;
        const normalized = normalizeNameFields(filteredData);
        yield handleSubmit(normalized, av_zone);
        yield handleSavedSearchOptIn(normalized);
        if (Object.values(consentItems).some((item) => item.name === cookieConsent && item.consent)) {
            setPrefillDataCookie(data);
        }
        close();
    });
    useEffect(() => {
        if (postLeadError && onError) {
            onError();
        }
    }, [postLeadError, onError]);
    return postLeadError ? (_jsx(ContactFormError, { close: close })) : (_jsx(ContactForm, { contactFormDatas: contactFormSection, loading: loading, onSubmit: handleSubmitAndClose, avZone: av_zone, isModal: isModal }));
};
